import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import moment from 'moment';

// Global Types
import { AppState } from 'services/types';

// Global Selectors
import { makeSelectTimesheetValue } from 'services/timesheets/selectors';

interface OwnProps {
    timesheetId: number;
}

interface ConnectedProps {
    lastExportedAt?: string | null;
}

type Props = OwnProps & ConnectedProps;

export class TimesheetLastExportedAtValue extends React.PureComponent<Props> {
    render(): string | null {
        const { lastExportedAt } = this.props;
        if (!lastExportedAt) {
            return null;
        }
        return moment(lastExportedAt).format('MMM D h:mm A');
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    lastExportedAt: makeSelectTimesheetValue('lastExportedAt')
});

export default connect(mapStateToProps)(TimesheetLastExportedAtValue);
